var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAvlCategoryNotIdentified = function SvgAvlCategoryNotIdentified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    fillRule: "evenodd",
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-5.392 3.382-4.384-8.768a.25.25 0 0 0-.448 0l-4.384 8.768c-.112.225.154.481.38.37.932-.455 2.58-1.124 4.228-1.124 1.648 0 3.296.669 4.228 1.124.226.111.492-.145.38-.37",
    clipRule: "evenodd"
  })));
};
export default SvgAvlCategoryNotIdentified;